import './css/style.css';
import MainBrain from './js/MainBrain';

// eslint-disable-next-line
new MainBrain()



// WEBPACK FOOTER //
// ./src/app.js